import { Tooltip } from "@mui/material";
import React from "react";
import EABadge from "../Badge/EABadge";

interface IProps {
  title: string;
  variant?: "filled" | "outlined" | "icon";
  color?: "primary" | "secondary";
  onClick?: () => void;
  icon: React.ReactNode;
  disabled?: boolean;
  badgeValue?: string | number;
}

const EAIconButton: React.FC<IProps> = ({
  title,
  variant = "filled",
  color = "primary",
  onClick = () => {},
  icon,
  disabled,
  badgeValue = "",
}) => {
  return (
    <Tooltip title={title}>
      <button
        className={`icon-button icon-button--${variant} icon-button--${color}`}
        onClick={onClick}
        disabled={disabled}
      >
        <EABadge value={badgeValue}>
          <span className="icon-button-icon">{icon}</span>
        </EABadge>
      </button>
    </Tooltip>
  );
};

export default EAIconButton;
